import React, { useState } from 'react';
import { RatesProductByURLType } from '../product';

interface StarRatingComponentProps {
    rate: RatesProductByURLType;
    onUpdate: (id: number, newRating: number) => void;
}

const StarRatingComponent: React.FC<StarRatingComponentProps> = ({ rate, onUpdate }) => {

    const [rating, setRating] = useState<number>(rate.rate_rate);
    const handleRatingChange = (newRating: number) => {
        setRating(newRating);
        onUpdate(rate.id, newRating);
    };

    return (
        <div className="flex items-center justify-between h-9 border rounded p-2">
            <div className="text-gray-700 h-5 w-[40%]">{rate.RateProperty.rate_property_title} : </div>
            <div className="rating-group flex h-5 flex-row-reverse w-[60%] space-x-reverse space-x-1 justify-between">
                {[...Array(5)].map((_, index) => {
                    const value = 5 - index;
                    return (
                        <React.Fragment key={index}>
                            <input
                                className="hidden"
                                type="radio"
                                name={`rating-${rate.id}`}
                                id={`star${value}-${rate.id}`}
                                value={value}
                                checked={rating === value}
                                onChange={() => handleRatingChange(value)}
                            />
                            <label
                                className={`rating__label h-5 cursor-pointer text-2xl ${rating >= value ? 'text-yellow-400' : 'text-gray-300'}`}
                                htmlFor={`star${value}-${rate.id}`}
                            >
                                ★
                            </label>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default StarRatingComponent;

